import axiosClient from './axiosClient';

export const getDrives = () => {
  return axiosClient.get('/admin/drives');
};

export const getDriveById = (id) => {
  return axiosClient.get(`/admin/drives/${id}`);
};

export const createDrive = (data) => {
  return axiosClient.post('/admin/drives', data);
};

export const updateDrive = (id, data) => {
  return axiosClient.put(`/admin/drives/${id}`, data);
};

export const deleteDrive = (id) => {
  return axiosClient.delete(`/admin/drives/${id}`);
};

export const publishDrive = (id) => {
  return axiosClient.post(`/admin/drives/${id}/publish`);
};
